import { LoadingIndicator, Flex } from '@qga/roo-ui/components';

const LoadingPage = () => (
  <Flex alignItems="center" justifyContent="center" minHeight="26rem" flexDirection="column" p={8}>
    <LoadingIndicator color="brand.primary" delay="1s" aria-label="Loading" />
  </Flex>
);

export default LoadingPage;
